function custom_delete_with_confirmation(url, id, question, object = '', callback = function() {}, falseCallback = function() {}, method = 'POST') {
    var $ = jQuery.noConflict();

    $('body').isLoading('dark');
    $.ajax({
        url: '/ajax/getDeletionPreventors/'+object+'/'+id,
        type: 'GET',
        success: function(data) {
            $('body').doneLoading();
            if(data.length > 0) {
                var arr = [];
                data.forEach(function (row) {
                    arr.push('<p class="callout alert">' + row + '</p>')
                });
                var html = '<h1>Kan niet worden verwijderd</h1>' + arr.join('');
                html = html + '<div class="text-center"><button class="button primary retry">Opnieuw proberen</button> <button class="button secondary close-reveal-modal">Annuleren</button></div>';
                foundationPopup(html, function (elm, popup) {
                    elm.find('.retry').click(function() {
                        popup.close();
                        custom_delete_with_confirmation(url,id, question, object, callback);
                        return false;
                    });
                });
            } else {
                confirm(question, function() {
                    $('body').isLoading('dark');

                    $.ajax({
                        url: url,
                        data: {id: id},
                        type: method,
                        success: function(data) {
                            $('body').doneLoading();
                            $('.reveal').trigger('onDelete-' + object + '-' + id);
                            $('[data-id="' + id + '"][data-object-type="' + object + '"]').each(function() {
                                const tr = $(this);
                                const table = tr.parents('table');
                                if (table.is('[data-reloadable-url]') && table.find('tbody tr').length === 1) {
                                    table.reloadThisElement();
                                } else {
                                    tr.remove();
                                }
                            });
                            if(callback === undefined || typeof callback === 'boolean') {
                                reload_location_if_needed(callback);
                            } else {
                                callback();
                            }
                        },
                        error: function(e) {
                            $('body').doneLoading();
                            squde_flash("Er ging helaas iets mis.", "alert");
                        }
                    });

                }, function() {
                    if (falseCallback) {
                        falseCallback();
                    }
                }, true);
            }
        },
        error: function(e) {
            $('body').doneLoading();
            squde_flash("Er ging helaas iets mis tijdens het controleren van verwijderen.", "alert");
        }
    });

    return false;
}
